import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { interval } from 'rxjs';
import { DidDataRetrievalService } from 'src/app/services/apiHandler/did-data-retrieval/did-data-retrieval.service';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';

@Component({
    selector: 'app-query-control-bar',
    templateUrl: './query-control-bar.component.html',
    styleUrls: ['./query-control-bar.component.scss'],
})
export class QueryControlBarComponent implements OnDestroy {
    public aliveCheckInterval: number = 1000;
    public queryLive: boolean = false;
    public frequency: number = 0;
    public started: boolean = false;
    timer: any;
    @Output() queryStarted = new EventEmitter<boolean>();

    constructor(
        private apiDataConnection: DidDataRetrievalService,
        private apiGwConnection: GatewayConnectionService,
        private _snackBar: MatSnackBar
    ) {
        this.apiDataConnection.stopDataQuery();
        this.subscribeDataQueryState();
        this.timer = interval(1000).subscribe(() => {
            this.fetchFrequency();
        });
    }

    ngOnDestroy(){
        this.apiDataConnection.stopSendQueryAliveState();
        this.stopDataQuery()
        this.timer.unsubscribe();
    }

    private fetchFrequency(){
        if(this.started) {
            this.frequency = this.apiDataConnection.queryFrequency;
        }
    }

    private subscribeDataQueryState() {
        this.apiDataConnection.queryLiveObs.subscribe((queryLive) => {
            this.queryLive = queryLive;
        });
    }

    public startDataQuery(): void {
        if (!this.apiGwConnection.gatewayConnected) {
            this.apiGwConnection.connectToGateway().subscribe((data): void => {
            });
            let snackBarRef = this._snackBar.open(
                'Connection to the gateway had to be established. It may be necessary to restart the data recording.',
                '',
                { duration: 5000 }
            );
        }
        this.apiDataConnection.cleanDataPoints();
        this.apiDataConnection.startDataQuery();
        this.started = true;
        this.queryStarted.emit(this.started);
        this.apiDataConnection.setStartTime(Date.now());
    }

    public stopDataQuery(): void {
        this.apiDataConnection.stopDataQuery();
        this.started = false;
        this.queryStarted.emit(this.started);
    }

    public cleanDataPoints(): void {
        this.apiDataConnection.cleanDataPoints();
    }
}
